import { gql } from '~/techstyle-shared/react-graphql';

// Reference: https://studio.apollographql.com/graph/fashionos/variant/dev/schema/reference/objects/ProductListResult?query=productlisting
// Previous version: {BASE_PRODUCTS_PRICING_QUERY_BFF} from '~/techstyle-shared/react-graphql/queries/products';

// TODO: remove unnecessary fields
const PRODUCTS_PRICING_QUERY_BFF = gql`
  fragment PricingFields on CustomerProductPrice {
    final
    finalDetails {
      displayOnPdp
      promoCode
      promoLabel
      promoPrice
      promoTypeId
    }
    masterProductId
    sales
    vip
    retail
    outlet
    pricingDatasource {
      sourceUrl
      version
    }
  }

  query CioBrowseGridPricingBFF(
    $productQuery: ProductQuery
    $size: Int
    $sort: Sort
    $from: Int
    $retailDiscounting: Boolean
  ) {
    productListing(
      from: $from
      productQuery: $productQuery
      size: $size
      sort: $sort
    ) {
      products {
        pricing(retailDiscounting: $retailDiscounting) {
          ...PricingFields
        }
      }
    }
  }
`;

/**
 *
 * Function to fetch BFF pricing data using GraphQL via Apollo client.
 *
 * @param {Object} apolloClient - Apollo client instance
 * @param {Array} masterProductIds - Array of master product IDs
 * @param {boolean} isVip - Flag to indicate if the user is a VIP member
 * @returns {Promise} - Promise that resolves to the pricing data
 */
const getGqlPricingDataBFF = ({
  apolloClient,
  masterProductIds,
  isVip = false,
}) => {
  const productPricingVariables = {
    productQuery: {
      masterProductId: {
        in: masterProductIds.map((id) => Number(id)),
      },
    },
    retailDiscounting: !isVip,
  };

  return apolloClient.query({
    context: {
      clientName: 'supergraph',
      headers: {
        'x-datasource-version': 'bff',
      },
    },
    query: PRODUCTS_PRICING_QUERY_BFF,
    variables: productPricingVariables,
    errorPolicy: 'all',
  });
};

export default getGqlPricingDataBFF;
